(function () {
  'use strict';

  angular.module('sempraWebapp').factory('messagesStore', messagesStoreFactory);

  /** @ngInject */
  function messagesStoreFactory (dispatcher, EventEmitter, messageActions, ActionTypesEnum) {
    var MessagesStore = new EventEmitter(),
      messagesImmutable = null, messagesKarcherImmutable = null;

    MessagesStore.events = Object.freeze({
      CHANGE: 'change',
      CHANGE_KARCHER: 'change Karcher'
    });

    MessagesStore.getMessages = function () {
      return messagesImmutable !== null
        ? messagesImmutable.toJSON()
        : null;
    };

    MessagesStore.getKarcherMessages = function () {
      return messagesKarcherImmutable !== null
          ? messagesKarcherImmutable.toJSON()
          : null;
    };

    MessagesStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.GET_ALARM_MESSAGES:
          messagesImmutable = Immutable.fromJS(actionData.payload);
          MessagesStore.emit(MessagesStore.events.CHANGE);
          break;
        case ActionTypesEnum.GET_ALARM_KARCHER_MESSAGES:
          messagesKarcherImmutable = Immutable.fromJS(actionData.payload);
          MessagesStore.emit(MessagesStore.events.CHANGE_KARCHER);
          break;
      }
    });

    return MessagesStore;
  }
})();
